export default "__VITE_ASSET__CIZPv5Oi__"